import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Building2,
  Users,
  MapPin,
  Package,
  Calendar,
  Tags,
  FileText,
  LogOut,
} from 'lucide-react';
import { useAuthStore } from '../../store/auth-store';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/businesses', icon: Building2, label: 'Businesses' },
  { to: '/trainers', icon: Users, label: 'Trainers' },
  { to: '/facilities', icon: MapPin, label: 'Facilities' },
  { to: '/products', icon: Package, label: 'Products' },
  { to: '/categories', icon: Tags, label: 'Categories' },
  { to: '/trainings', icon: Calendar, label: 'Trainings' },
  { to: '/audit-logs', icon: FileText, label: 'Audit Logs' },
];

export function Sidebar() {
  const { user, logout } = useAuthStore();

  return (
    <div className="w-64 bg-surface-app-elevated text-ink-primary border-r border-white/10 flex flex-col h-screen">
      {/* Logo */}
      <div className="p-6 border-b border-white/10">
        <h1 className="font-display text-2xl font-semibold tracking-tight">Spotto Admin</h1>
        <p className="text-sm text-ink-muted mt-1">Platform Management</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-brand-primary text-white shadow-lg shadow-brand-primary/20'
                  : 'text-ink-secondary hover:bg-white/10 hover:text-white'
              }`
            }
          >
            <item.icon size={20} />
            <span className="font-medium">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* User Info */}
      <div className="p-4 border-t border-white/10">
        <div className="mb-3">
          <p className="text-sm font-medium text-ink-primary">{user?.email}</p>
          <p className="text-xs text-ink-muted mt-1">Superadmin</p>
        </div>
        <button
          onClick={logout}
          className="flex items-center gap-3 px-4 py-2 w-full rounded-lg text-ink-secondary hover:bg-white/10 hover:text-white transition-colors"
        >
          <LogOut size={20} />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
}
